import ApiService from "./base";
import { config } from "@/utils/config";
export default class InvoicesService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    async getInvoices(filters, customerId) {
        const params = new URLSearchParams();
        if (filters?.status) {
            params.append("status", filters.status);
        }
        if (filters?.startDate) {
            params.append("startDate", filters.startDate);
        }
        if (filters?.endDate) {
            params.append("endDate", filters.endDate);
        }
        if (customerId) {
            params.append("customerId", customerId);
        }
        const queryString = params.toString();
        const url = queryString ? `/direct/invoices?${queryString}` : "/direct/invoices";
        const response = await this.get({
            url
        });
        const transformedInvoices = response.data.invoices.map((invoice)=>({
                ...invoice,
                issuedAt: invoice.issuedAt,
                dueAt: invoice.dueAt,
                lineItems: (invoice.lineItems || []).map((item)=>({
                        lineId: item.LineId || item.lineId,
                        apiKeyId: item.ApiKeyId || item.apiKeyId,
                        usageValue: item.UsageValue || item.usageValue,
                        usageUnit: item.UsageUnit || item.usageUnit,
                        chargeModel: item.ChargeModel || item.chargeModel,
                        amount: item.Amount || item.amount,
                        metadata: item.Metadata || item.metadata
                    }))
            }));
        return {
            ...response.data,
            invoices: transformedInvoices
        };
    }
    async getInvoiceById(invoiceId, customerId) {
        try {
            const response = await this.getInvoices(undefined, customerId);
            return response.invoices.find((invoice)=>invoice.invoiceId === invoiceId) || null;
        } catch (error) {
            return null;
        }
    }
    async updateInvoiceStatus(invoiceId, status, customerId, amountPaid) {
        const params = new URLSearchParams();
        if (customerId) {
            params.append("customerId", customerId);
        }
        const queryString = params.toString();
        const url = queryString ? `/direct/invoices/${invoiceId}/status?${queryString}` : `/direct/invoices/${invoiceId}/status`;
        const response = await this.patch({
            url,
            data: {
                status,
                ...amountPaid !== undefined ? {
                    amountPaid
                } : {}
            }
        });
        return response.data.invoice;
    }
    async generateInvoices(request) {
        const response = await this.post({
            url: "/direct/invoices/generate",
            data: request
        });
        return response.data;
    }
    async getDownloadUrl(invoiceId, customerId, forceRegenerate) {
        const params = new URLSearchParams();
        if (customerId) {
            params.append("customerId", customerId);
        }
        if (forceRegenerate) {
            params.append("forceRegenerate", "true");
        }
        const queryString = params.toString();
        const url = queryString ? `/direct/invoices/${invoiceId}/download?${queryString}` : `/direct/invoices/${invoiceId}/download`;
        const response = await this.get({
            url
        });
        return response.data;
    }
}
